import { apiClient } from './apiClient';

const fetchChaosActions = async () => {
  return await apiClient.get('/chaos/actions');
};

const initChaosDefaults = async () => {
  return await apiClient.post('/chaos/actions/init-defaults');
};

const updateChaosAction = async (id, payload) => {
  return await apiClient.patch(`/chaos/actions/${id}`, payload);
};

const testChaosAction = async (id) => {
  return await apiClient.post(`/chaos/actions/${id}/test`);
};

const createTwitchReward = async (id) => {
  return await apiClient.post(`/chaos/actions/${id}/create-twitch-reward`);
};

const bindReward = async (id, rewardId) => {
  return await apiClient.post(`/chaos/actions/${id}/bind-reward`, { rewardId });
};

const fetchTwitchRewards = async () => {
  return await apiClient.get('/chaos/twitch/rewards');
};

const createManualTwitchReward = async (payload) => {
  return await apiClient.post('/chaos/twitch/rewards', payload);
};

const syncTwitchRewards = async () => {
  return await apiClient.post('/chaos/twitch/sync-rewards');
};

const ensureChaosEventSub = async () => {
  return await apiClient.post('/chaos/twitch/ensure-eventsub');
};

const fetchChaosClientStatus = async () => {
  return await apiClient.get('/chaos/client/status');
};

const generateChaosConnectToken = async (deviceName) => {
  return await apiClient.get('/chaos/client/connect-token', { deviceName });
};

const fetchChaosLogs = async () => {
  return await apiClient.get('/chaos/logs');
};

export const chaosApi = {
  fetchChaosActions,
  initChaosDefaults,
  updateChaosAction,
  testChaosAction,
  createTwitchReward,
  bindReward,
  fetchTwitchRewards,
  createManualTwitchReward,
  syncTwitchRewards,
  ensureChaosEventSub,
  fetchChaosClientStatus,
  generateChaosConnectToken,
  fetchChaosLogs
};
